type SectionHeadingProps = {
  index: string;
  title: string;
  subtitle?: string;
  accent?: 'primary' | 'accent' | 'secondary';
};

const accentBar: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function SectionHeading({ index, title, subtitle, accent = 'primary' }: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
      <div className="flex items-center gap-3">
        <span className="font-heading font-bold text-2xl md:text-3xl text-background-300 leading-none">{index}</span>
        <span className={`w-1 h-7 rounded-full ${accentBar[accent]}`}></span>
        <div>
          <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950 leading-tight">{title}</h2>
          {subtitle ? <p className="mt-0.5 text-xs md:text-sm text-foreground-500">{subtitle}</p> : null}
        </div>
      </div>
    </div>
  );
}